export enum IProductType {
  COCO = 'COCO',
  DISE = 'DISE',
  CERTIFICATE = 'CERTIFICATE',
}
